import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import "./index.css";
import "typeface-work-sans";

ReactDOM.render(<App />, document.getElementById("root"));
